export const ExclamationIcon = () => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M27.6011 23.2623L21.2492 12.2579C20.2483 10.5247 17.7519 10.5247 16.7511 12.2579L10.3992 23.2623C9.39824 24.9924 10.6495 27.1551 12.6483 27.1551H25.352C27.3508 27.1551 28.6022 24.9924 27.6011 23.2623ZM24.6167 25.1067H13.3836C12.6329 25.1067 12.1664 24.2973 12.5402 23.6485L18.1567 13.92C18.5306 13.2712 19.4697 13.2712 19.8436 13.92L25.4601 23.6485C25.8339 24.2973 25.3674 25.1067 24.6167 25.1067Z"
        fill="#FF4F55"
      />
      <path
        d="M18.9998 15.8306C18.6345 15.8306 18.3379 16.1272 18.3379 16.4925V20.6632C18.3379 21.0286 18.6345 21.3252 18.9998 21.3252C19.3659 21.3252 19.6617 21.0286 19.6617 20.6632V16.4925C19.6617 16.1264 19.3651 15.8306 18.9998 15.8306Z"
        fill="#FF4F55"
      />
      <path
        d="M18.9998 22.3125C18.6345 22.3125 18.3379 22.6091 18.3379 22.9744C18.3379 23.3397 18.6345 23.6363 18.9998 23.6363C19.3659 23.6363 19.6617 23.3397 19.6617 22.9744C19.6617 22.6091 19.3651 22.3125 18.9998 22.3125Z"
        fill="#FF4F55"
      />
    </svg>
  );
};
